<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_40 col_20'><span class='brt high default' id='text1'>NATIONAL RAILROAD  PASSENGER CORPORATION</span>  </div>
  <div class='lgr_05 col_75'><span class='default' id='text2'>S141G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><dynamic-field [id]='"scrntm"' [size]=8 [line]=2 [column]=1 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_47 col_17'><span class='brt high default' id='text3'>AMTRAK AVAILABILITY LOCATION MAINTENANCE SCREEN</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_47 col_17'><span class='brt high default' id='text4'>-----------------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text5'>ENTER REQUIRED FIELDS AND HIT APPRPPRIATE FUNCTION KEY:</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text6'>-------------------------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_05'><span class='default' id='text7'>LOCN CD: </span>  </div>
  <div class='lgr_03 col_20'><dynamic-field [id]='"locncd"' [size]=3 [line]=8 [column]=20 [(ngModel)]='locncd'></dynamic-field></div>
  <div class='lgr_00 col_24'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_05'><span class='default' id='text9'>ZONE ID: </span>  </div>
  <div class='lgr_04 col_20'><dynamic-field [id]='"zoneid"' [size]=4 [line]=10 [column]=20 [(ngModel)]='zoneid'></dynamic-field></div>
  <div class='lgr_00 col_25'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><span class='default' id='text11'>PF3=EXIT</span>  </div>
  <div class='lgr_10 col_12'><span class='default' id='text12'>PF4=RETURN</span>  </div>
  <div class='lgr_12 col_25'><span class='default' id='text13'>ENTER=SELECT</span>  </div>
  <div class='lgr_07 col_40'><span class='default' id='text14'>PF5=ADD</span>  </div>
  <div class='lgr_10 col_50'><span class='default' id='text15'>PF6=UPDATE</span>  </div>
</div>
</div>
